import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptPerson } from "../adapters/adaptPerson";

const fetchPerson = async (id: string) => {
	const response = await cmsClient.get<IRetailUser>(
		`/homepage/admin/store/user/${id}/`
	);

	return response.data;
};

const usePerson = (id: string) => {
	const query = useQuery(["admin-person", id], () => fetchPerson(id), {
		select: adaptPerson,
		enabled: !!id
	});

	return query;
};

export default usePerson;
